import React, { useEffect } from "react";
import {
    FormControl,
    InputAdornment,
    InputLabel,
    OutlinedInput,
} from "@mui/material";
import Icon from "../../components/Icon";
import Status from "../../types/enum/Status";
import theme from "../../styles/theme";
import Button from "../../components/Button";

type SearchBoxProps = {
    resetSearch: boolean | undefined;
    label: string;
    defaultKeyword?: string;
    onSearch: (x: string) => void;
    width?: number | undefined;
    keyword?: string;
};
function SearchBox({
    resetSearch,
    label,
    defaultKeyword,
    onSearch,
    width,
    keyword,
}: SearchBoxProps): JSX.Element {

    const [value, setValue] = React.useState<string>(defaultKeyword || "");

    useEffect(() => {
        setValue("");
    }, [resetSearch]);

    return (
        <>
            <FormControl
                size="small"
                sx={{
                    mr: 1,
                    width: width ? width : "200px",
                    boxShadow: theme.shadow(2, Status.default),
                }}
                variant="outlined"
            >
                <InputLabel htmlFor="component-outlined">{label}</InputLabel>
                <OutlinedInput
                    id="component-outlined"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    endAdornment={
                        (value !== "") ? (
                            <InputAdornment
                                onClick={() => {
                                    onSearch("");
                                    setValue("");
                                }}
                                position="end"
                                style={{ cursor: "pointer" }}
                            >
                                <Icon name={"close"}></Icon>
                            </InputAdornment>
                        ) : (
                            <InputAdornment position="end">
                                <Icon name={"search"}></Icon>
                            </InputAdornment>
                        )
                    }
                    label={label}
                />
            </FormControl>
            <Button
                disabled={value === ""}
                onClick={() => {
                    onSearch(value);
                }}>
                Search
            </Button>
        </>
    );
}
export default SearchBox;